import { Injectable } from '@angular/core';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { IndexedDbService } from '../../shared/services/indexedDb.service';
import { Observable, of } from 'rxjs';
import { map, flatMap } from 'rxjs/operators';
import { Inspection } from '../../shared/models';
import { AppConstants } from '../../utils/appConstants.class';
import { DataService } from '../../shared/services';

@Injectable()
export class AssociateEqupmentFactoryService extends InspectionFactoryService {
  constructor(indexedDb: IndexedDbService, dataService: DataService) {
    super(indexedDb, dataService);
  }

  public updateAssociates(inspectionId: string, pluginId: string, data: any): Observable<any> {
    if (this.isManager) {
      return this.dataService.getPlugin(inspectionId, pluginId).pipe(
        map((plugin) => {
          if (plugin) {
            plugin.config = data;
            return { plugin };
          }
        })
      );
    }
    return this.getInspection(inspectionId).pipe(
      flatMap((inspection) => {
        const plugin = inspection.allPlugins.find((p) => p.id === pluginId);
        if (plugin) {
          const obs = [];
          obs.push(this.updateParentId(inspection, data.addedInspectionIds, true));
          obs.push(this.updateParentId(inspection, data.deletedInspectionIds, false));
          plugin.config = data;
          plugin.etag = new Date();
          return Observable.zip(...obs).pipe(
            map((res) => {
              this.updateInspection(inspection);
              return { res, plugin };
            })
          );
        }
        return null;
      })
    );
  }

  private updateParentId(inspection: Inspection, childrenIds: string[], add: boolean): Observable<any> {
    if (childrenIds) {
      if (add) {
        return this.indexedDb.readAll(AppConstants.INDEXEDDB_TABLES.inspections).pipe(
          map((inspections) => {
            childrenIds.forEach((id) => {
              const child = inspections.find((i) => i.id === id);
              if (child && !inspection.children.some((c) => c.id === id)) {
                inspection.children.push(child);
              }
            });
            return childrenIds;
          })
        );
      } else {
        childrenIds.forEach((id) => {
          inspection.children = inspection.children.filter((c) => c.id !== id);
        });
        return of(childrenIds);
      }
    }
    return null;
  }
}
